import React from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { Link, useLocation } from "react-router-dom";
import profile1 from "../Images/ic-user-black.png";
import profile from "../Images/ic-userss.png";
import signOut from "../Images/humbleicons_logouts.png";
import { BLACK, GRAY, PRIMARY, WHITE } from "../styles/color";
import { Box } from "@mui/material";
import order from "../Images/ic-cart-black.png";
import order1 from "../Images/ic-cartss.png";
import event from "../Images/ic-calendar-event.png";
import event1 from "../Images/ic-calendar-event-black.png";
import setting from "../Images/ic-setting-black.png";
import setting1 from "../Images/ic-setting.png";
import notification from "../Images/ic-notification-black.png";
import notification1 from "../Images/ic-notification.png";
import { useDispatch } from "react-redux";
import { clearCart } from "../Features/services/cartSlice";
import { useNavigate } from "react-router-dom";
import { useThemeColors } from "../Context/Theme";
import { removeAllCookies } from "../LoginModule/LoginUtility";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";
import CustomButton from "../components/CustomButton";


const Sidebar = () => {
  const { primaryColor, secondaryColor, textColor, buttonColor, linkColor, backgroundColor, logo,
    fontFamily,
  } = useThemeColors();
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const eventName = sessionStorage.getItem("eventName");
  const menuItems = [
    {
      text: "Personal Info",
      path: `/events/${eventName}/profile`,
      icons: [profile1, profile],
    },
    {
      text: "My Orders",
      path: `/events/${eventName}/orders/0`,
      icons: [order, order1],
    },
    { text: "Events", path: "", icons: [event1, event] },
    { text: "Notifications", path: `/events/${eventName}/notification`, icons: [notification, notification1] },
    { text: "Settings", path: "", icons: [setting, setting1] },
  ];

  const handleLogout = () => {

    dispatch(clearCart());
    localStorage.removeItem("loggedIn");
    localStorage.removeItem("token");
    localStorage.removeItem("cart");
    localStorage.removeItem("user_Id");
    localStorage.removeItem("email");
    sessionStorage.removeItem("cartId");
    removeAllCookies()
    navigate(`/events/${eventName}`);
    window.location.reload();
  };

  const handleLogoutClick = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <React.Fragment>
      <Box
        className="py-3 "
        sx={{
          width: "100%",
          maxWidth: { xs: "100%", sm: "263px" },
          backgroundColor: "white",
          borderRadius: "21px",
          boxShadow: "0px 4px 19px 0px #D6D6D640",

          "@media (max-width: 600px)": {
            maxWidth: "100%",
            padding: "10px",
            fontFamily: fontFamily || "poppins",
          },
        }}
      >
        <List component="nav" aria-label="main mailbox folders">
          {menuItems.map((item, index) => (
            <Link to={item.path} className="text-decoration-none" key={index}>
              <ListItemButton
                selected={location.pathname === item.path}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor:
                    location.pathname === item.path ? "white" : "transparent",
                  color: location.pathname === item.path ? textColor : "gray",
                  borderLeft:
                    location.pathname === item.path ? `3px solid ${primaryColor}` : "none",
                  padding: "12px 16px",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                  "@media (max-width: 600px)": {
                    padding: "8px 12px",
                  },
                  fontFamily: fontFamily || "poppins",
                }}
              >
                <img
                  src={
                    location.pathname === item.path
                      ? item.icons[0]
                      : item.icons[1]
                  }
                  className="mr-4"
                  alt={item.text}
                  style={{
                    width: "24px",
                    marginRight: "16px",
                    "@media (max-width: 600px)": {
                      width: "20px",
                      marginRight: "12px",
                    },
                  }}
                />
                <ListItemText
                  primary={item.text}
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: "14px", sm: "16px" },
                    lineHeight: "24px",
                    fontFamily: fontFamily || "poppins",
                  }}
                  primaryTypographyProps={{
                    style: { fontFamily: fontFamily || 'Poppins, sans-serif' }
                  }}
                />
              </ListItemButton>
            </Link>
          ))}
          <ListItemButton
            onClick={handleLogoutClick}
            selected={false}
            className="rounded-3"
            sx={{
              display: "flex",
              alignItems: "center",
              padding: "12px 16px",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
              "@media (max-width: 600px)": {
                padding: "8px 12px",
              },
              fontFamily: fontFamily || "poppins",
            }}
          >
            <Box
              component="img"
              src={signOut}
              className="mr-4"
              alt="Logout"
              style={{
                width: "24px",
                marginRight: "16px",
                fontFamily,
                "@media (max-width: 600px)": {
                  width: "20px",
                  marginRight: "12px",
                },
              }}
            />
            <ListItemText
              primary="Logout"
              sx={{
                fontWeight: 400,
                fontSize: { xs: "14px", sm: "16px" },
                lineHeight: "24px",
                color: "#FF6767",
                fontFamily: fontFamily || "poppins",
              }}
            />
          </ListItemButton>
        </List>
      </Box>
         <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="lg">
              <DialogTitle>Logout</DialogTitle>
              <DialogContent>
                <Typography>Are you sure you want to logout?</Typography>
              </DialogContent>
              <DialogActions sx={{ justifyContent: "center", padding: "30px" }}>
      
                <CustomButton onClick={handleLogout}
                  text="Yes"
                  size="sm"
                  block={true}
                  className="btn-sm"
                />
      
                <CustomButton
                  text="No"
                  size="sm"
                  block={true}
                  className="btn-sm"
                  bgcolor={"black"}
                  onClick={() => setOpenDialog(false)}
                />
      
              </DialogActions>
            </Dialog>
    </React.Fragment>
  );
};

export default Sidebar;
